"use strict";
/**
 * Cómo mostrar el resultado de un partido según cómo lo cargó el organizador.
 *
 * El marcador se guarda siempre como `team1Goals`/`team2Goals`, pero cuando el
 * organizador elige "Por diferencia" solo sabemos quién ganó y por cuánto: los
 * goles quedan codificados como (diferencia, 0). Mostrar eso como "0 - 2" es
 * inventar un marcador que nadie cargó. Con `scoreMode === 'difference'` el
 * resultado se muestra como "Ganó X por 2 goles" (o "Empate").
 *
 * Compartido por web y mobile. El server tiene su copia CommonJS en
 * `server/src/utils/matchResultLabel.js`; mantener las dos iguales.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMatchResultDisplay = exports.formatGoalDifference = exports.isDifferenceScoreMode = void 0;
function isDifferenceScoreMode(scoreMode) {
    return scoreMode === 'difference';
}
exports.isDifferenceScoreMode = isDifferenceScoreMode;
function formatGoalDifference(difference) {
    return `${difference} ${difference === 1 ? 'gol' : 'goles'}`;
}
exports.formatGoalDifference = formatGoalDifference;
function getMatchResultDisplay(input) {
    const { team1Goals, team2Goals, scoreMode } = input;
    const team1Name = input.team1Name || 'Equipo 1';
    const team2Name = input.team2Name || 'Equipo 2';
    if (typeof team1Goals !== 'number' || typeof team2Goals !== 'number') {
        return { kind: 'none', winner: null, winnerName: null, difference: 0, label: '' };
    }
    const winner = team1Goals > team2Goals ? 1 : team2Goals > team1Goals ? 2 : null;
    const winnerName = winner === 1 ? team1Name : winner === 2 ? team2Name : null;
    const difference = Math.abs(team1Goals - team2Goals);
    if (isDifferenceScoreMode(scoreMode)) {
        if (winner === null) {
            return { kind: 'draw', winner, winnerName, difference, label: 'Empate' };
        }
        return {
            kind: 'difference',
            winner,
            winnerName,
            difference,
            label: `Ganó ${winnerName} por ${formatGoalDifference(difference)}`,
        };
    }
    return { kind: 'exact', winner, winnerName, difference, label: `${team1Goals} - ${team2Goals}` };
}
exports.getMatchResultDisplay = getMatchResultDisplay;
